const XPositionToOffset = {
  0: 3600,
  22: 7200,
  44: 10800,
  66: 14400,
  88: 18000,
  110: 21600,
  132: 25200,
  154: 0,
  176: 86400,
  198: 172800,
  220: 259200,
  242: 345600,
  264: 432000,
  286: 518400,
  308: 604800,
  330: 691200,
  352: 777600,
  374: 864000,
  396: 950400,
  418: 1036800,
  440: 1123200,
  462: 1209600,
  484: 1296000,
  506: 1382400,
  528: 1468800,
  550: 1555200,
  572: 1641600,
  594: 1728000,
  616: 1814400,
  638: 1900800,
  660: 1987200,
  682: 2073600,
  704: 2160000,
  726: 2246400,
  748: 2332800,
  770: 2419200,
  792: 2505600,
  814: 2592000,
}

export default XPositionToOffset



// WEBPACK FOOTER //
// ./src/components/sitewide/XPositionToOffset.js